/**
 * 菜单处理帮助类
 *
 * @format
 */

import { isEmpty, isHttp, uniqueSlash } from '@power/utils';

const MENU_OPEN_TARGET = '_blank';

// 常量
const menuUtil = {
	ID_KEY: 'id',
	PARENT_KEY: 'parentId',
	CHILD_KEY: 'children',
	LEVEL_KEY: 'level',
	NAME_KEY: 'alias',
	LABEL_KEY: 'name',
	PATH_KEY: 'path',
	OPEN_KEY: 'open', // 打开新窗口
	ICON_KEY: 'icon',
	URL_KEY: 'defaultUrl',
	CACHE_KEY: 'cache',
	DISPLAY_IN_MENU_KEY: 'displayInMenu',
	IS_FOLDER_KEY: 'isFolder',

	setFullPath(node, lastNamePath = []) {
		if (node?.length === 0) {
			return;
		}
		if (node?.length > 0) {
			node.map((item) => {
				menuUtil.setFullPath(item, lastNamePath.concat(item.fullPath));

				if (item.children && item.children.length > 0) {
					menuUtil.setFullPath(item.children, lastNamePath.concat(item.fullPath));
				}
			});
		} else {
			const {
				fullPath: nodeFullPath,
				path,
				meta: { sysType },
			} = node;
			let fullPath = '';
			const pathPrefix = lastNamePath.join('/') || '';
			if ('outer' === sysType) {
				if (isHttp(path)) {
					fullPath = path;
				} else {
					fullPath = `${window.location.origin}${path}`;
				}
			} else if (nodeFullPath) {
				fullPath = nodeFullPath;
			} else if (path.startsWith('/')) {
				fullPath = path;
			} else {
				fullPath = `/${path}`;
				fullPath = path.startsWith(pathPrefix) ? fullPath : pathPrefix + fullPath;
				fullPath = [...new Set(uniqueSlash(fullPath).split('/'))].join('/');
			}
			node.fullPath = fullPath;
		}
	},

	/**
	 * 转换成树结构
	 * @param {*} sNodes
	 */
	transformToTreeAndLevelFormat(sNodes) {
		if (sNodes == null || sNodes === undefined || sNodes.length === 0) {
			return [];
		}
		const node = menuUtil.transformToTreeFormat(sNodes);
		// 设置层级
		for (let i = 0; i < node.length; i++) {
			menuUtil.setSonNodeLevel(null, node[i]);
		}
		return node;
	},

	/**
	 * 转换成数组结构
	 * @param {*} sNodes
	 */
	transformToTreeFormat(sNodes) {
		let i, l;
		if (!this.ID_KEY || this.ID_KEY === '' || !sNodes) {
			return [];
		}
		if (sNodes instanceof Array) {
			const r: any[] = [];
			const tmpMap: any[] = [];
			for (i = 0, l = sNodes.length; i < l; i++) {
				tmpMap[sNodes[i][this.ID_KEY]] = sNodes[i];
			}
			for (i = 0, l = sNodes.length; i < l; i++) {
				if (tmpMap[sNodes[i][this.PARENT_KEY]] && sNodes[i][this.ID_KEY] !== sNodes[i][this.PARENT_KEY]) {
					if (!tmpMap[sNodes[i][this.PARENT_KEY]][this.CHILD_KEY]) {
						tmpMap[sNodes[i][this.PARENT_KEY]][this.CHILD_KEY] = [];
					}
					tmpMap[sNodes[i][this.PARENT_KEY]][this.CHILD_KEY].push(sNodes[i]);
				} else {
					r.push(sNodes[i]);
				}
			}
			return r;
		} else {
			return [sNodes];
		}
	},

	/**
	 * 设置儿子节点等级
	 * @param {*} parentNode
	 * @param {*} node
	 */
	setSonNodeLevel(parentNode, node) {
		if (!node) return;

		node[this.LEVEL_KEY] = parentNode ? parentNode[this.LEVEL_KEY] + 1 : 0;
		const nodeUrl = node[this.URL_KEY];
		node[this.PATH_KEY] = nodeUrl ? nodeUrl : `${parentNode ? parentNode[this.PATH_KEY] : ''}/${node[this.NAME_KEY]}`;
		if (!node[this.CHILD_KEY]) {
			return;
		}
		for (let i = 0, l = node[this.CHILD_KEY].length; i < l; i++) {
			if (node[this.CHILD_KEY][i]) {
				menuUtil.setSonNodeLevel(node, node[this.CHILD_KEY][i]);
			}
		}
	},

	// ===============导航菜单处理================================
	/**
	 * 处理菜单的数据成为前端可用的数据
	 * @param {*} data
	 */
	dealDataMenu(data) {
		return data.map((node) => {
			if (node[this.URL_KEY].indexOf('$token$') > -1) {
				node[this.URL_KEY] = node[this.URL_KEY].replaceAll('$token$', window.pData?.globalStore?.token || '');
			}
			const meta = {
				title: node[this.LABEL_KEY],
				type: 'dir' === node['resourceType'] ? 0 : 1,
				keepAlive: 'Y' === node[this.CACHE_KEY],
				icon: node[this.ICON_KEY],
				hideInMenu: !('Y' === node[this.DISPLAY_IN_MENU_KEY]),
				link: node[this.URL_KEY],
				orderNum: node[this.LEVEL_KEY],
				viewPath: node[this.URL_KEY],
				perms: node['apiPermissions'],
			};
			node.meta = meta;
			node.type = meta.type;
			node.orderNum = meta.orderNum;
			node.keepAlive = meta.keepAlive;
			node.viewPath = meta.viewPath;
			node.hidden = !('Y' === node[this.DISPLAY_IN_MENU_KEY]);
			node.isShow = 'Y' === node[this.DISPLAY_IN_MENU_KEY];
			node.router = node[this.URL_KEY];
			return node;
		});
	},
	/**
	 * 只过滤菜单的数据
	 * @param {*} data
	 */
	filterOnlyMenu(data) {
		return data.filter((d) => {
			return d.resourceType === 'menu';
		});
	},
	/**
	 * 过滤菜单的数据
	 * @param {*} data
	 */
	filterMenu(data) {
		return data.filter((d) => {
			return d.resourceType === 'dir' || d.resourceType === 'menu';
		});
	},
	/**
	 * 过滤菜单的显示的菜单数据
	 * @param {*} data
	 */
	getDisplayMenus(data) {
		const filterMenu = data.filter((d) => {
			return d[this.DISPLAY_IN_MENU_KEY] === 'Y';
		});
		return this.transformToTreeAndLevelFormat(JSON.parse(JSON.stringify(filterMenu)));
	},
	/**
	 * 获取导航菜单
	 * @param {*} menuList
	 */
	getHeaderMenus(menuList) {
		const headerMenus: any[] = [];
		for (const menu of menuList) {
			if (menu[this.DISPLAY_IN_MENU_KEY] === 'N') {
				continue;
			}
			const m = JSON.parse(JSON.stringify(menu));
			m.children = null;
			headerMenus.push(m);
		}
		return headerMenus;
	},
	//   /**
	//  * 获取当前激活的导航菜单
	//  * @param {*} navMenus
	//  */
	//   getActiveHeaderMenu: function(headerMenus, activeHeader) {
	//   // 首先取缓存
	//     if (activeHeader === 0 || activeHeader == null) {
	//       activeHeader = headerMenus[0][menuUtil.NAME_KEY]
	//     }
	//     return activeHeader
	//   },
	/**
	 *  获取当前激活的导航菜单
	 * @param {*} menuList
	 * @param {*} activeHeader
	 * @returns
	 */
	getActiveHeaderMenu(menuList, activeHeader) {
		if (!isEmpty(menuList)) {
			for (const menu of menuList as any) {
				if (menu[menuUtil.NAME_KEY] === activeHeader || menu[menuUtil.ID_KEY] === activeHeader) {
					// 兼容旧版本
					return menu;
				}
			}
			// 如果找不到取第一个
			return menuList[0];
		}
		return;
	},

	/**
	 *  获取当前激活的侧边栏
	 * @param {*} menuList 菜单列表
	 * @param {*} activeHeader 激活的菜单
	 * @param {*} layout 当前布局
	 * @returns
	 */
	getAsideMenus(menuList, activeHeader) {
		const activeHeaderMenu = this.getActiveHeaderMenu(menuList, activeHeader);
		if (!isEmpty(activeHeaderMenu)) {
			return activeHeaderMenu[this.CHILD_KEY];
		}
		return [];
	},
	getPermissions(menuList) {
		const permissions = {};
		if (!menuList || menuList.length <= 0) {
			return permissions;
		}
		const key = this.NAME_KEY;
		menuList.forEach((menu) => {
			permissions[menu[key]] = true;
		});
		return permissions;
	},
	/**
	 * 打开顶部菜单
	 * @param {*} vm
	 * @param {*} menu
	 * @returns
	 */
	// openHeader(vm, menu) {
	// 	const url = menu[this.URL_KEY];
	// 	if (url === undefined || url === '') {
	// 		vm.$message.closeAll();
	// 		vm.$message.warning(vm.$t('navbar.temporaryMenu'));
	// 		return;
	// 	}
	// 	const target = MENU_OPEN_TARGET;
	// 	if (target !== '_tab' && isHttp(url)) {
	// 		window.open(url, target === '_blank' ? target : url);
	// 	} else {
	// 		const name = menu[this.NAME_KEY];
	// 		vm.$router.push({
	// 			path: ROUTER_ALIAS_PREFIX + name,
	// 		});
	// 	}
	// },
	/**
	 * 打开指定菜单
	 * @param {*} vm
	 * @param {*} url
	 */
	open(vm, url) {
		const target = MENU_OPEN_TARGET;
		if (/^ibps-menu-empty-\d+$/.test(url) || url === undefined || url === '') {
			vm.$message.closeAll();
			vm.$message.warning(vm.$t('navbar.temporaryMenu'));
		} else {
			// iframe 方式
			if (isHttp(url)) {
				window.open(url, target === '_blank' ? target : url);
			} else {
				vm.$router.push({
					path: url,
				});
			}
		}
	},
};

export default menuUtil;

export { menuUtil };
